import React from "react"
import {
  ProgressSection,
  LevelTracker,
  LevelItem,
  LevelLabel,
  LevelInfo,
  ProgressBar,
  ProgressFill,
  RequirementsGrid,
} from "./Styles/ProgressTracker.styles"
import LevelCompleteBanner from "./LevelCompleteBanner"
import AdditionalRequirementsList from "./AdditionalRequirementsList"
import RequirementCard from "./RequirementCard"
import LevelIndicator from "./LevelIndicator"
import LevelProgressBar from "./LevelProgressBar"

export const LevelTrackerSection = ({
  levels,
  onLevelClick,
  suspensions,
  currentLevelKey,
  suspendedLevelKey,
  activeLevel,
}) => {
  // Check if there's an active GPTP suspension
  const hasGptpSuspension = suspensions?.some(s => s.code === "GPTP")

  return (
    <ProgressSection>
      <LevelTracker>
        {levels.map(level => (
          <LevelItem
            key={level.key}
            active={level.active}
            onClick={onLevelClick && (() => onLevelClick(level.key))}
          >
            <LevelInfo>
              <LevelLabel>{level.name}</LevelLabel>
              <LevelIndicator
                completed={level.completed}
                active={level.active}
                locked={level.locked}
                hasIncompleteRequirements={level.hasIncompleteRequirements}
                suspended={
                  hasGptpSuspension &&
                  level.key === (suspendedLevelKey || currentLevelKey)
                }
              />
            </LevelInfo>
            <ProgressBar completed={level.completed}>
              <ProgressFill percentage={level.progress} />
            </ProgressBar>
          </LevelItem>
        ))}
      </LevelTracker>
      <LevelProgressBar activeLevel={activeLevel} />
    </ProgressSection>
  )
}

export const RequirementsSection = ({
  shouldShowLevelCompleteBanner,
  currentLevel,
  levelCompletionDate,
  patRequirementWithWarning,
  additionalRequirements,
  activeLevel,
  shouldShowPATWarning,
  shouldShowAdditionalRequirements,
  onLevelClick,
}) => {
  if (shouldShowLevelCompleteBanner) {
    return (
      <>
        <LevelCompleteBanner
          levelName={currentLevel?.name}
          completionDate={levelCompletionDate}
        />
        {patRequirementWithWarning && (
          <RequirementsGrid>
            <RequirementCard
              requirement={patRequirementWithWarning}
              activeLevel={activeLevel}
              shouldShowPATWarning={shouldShowPATWarning}
            />
          </RequirementsGrid>
        )}
        {shouldShowAdditionalRequirements && (
          <AdditionalRequirementsList
            additionalRequirements={additionalRequirements}
          />
        )}
      </>
    )
  }

  return (
    <RequirementsGrid>
      {currentLevel?.requirements?.map(requirement => (
        <RequirementCard
          key={requirement.key}
          requirement={requirement}
          activeLevel={activeLevel}
          shouldShowPATWarning={shouldShowPATWarning}
        />
      ))}
      {shouldShowAdditionalRequirements && (
        <AdditionalRequirementsList
          additionalRequirements={additionalRequirements}
        />
      )}
    </RequirementsGrid>
  )
}
